import { render, staticRenderFns } from "./perFile1Wx.vue?vue&type=template&id=6191d447&scoped=true&"
import script from "./perFile1Wx.vue?vue&type=script&lang=js&"
export * from "./perFile1Wx.vue?vue&type=script&lang=js&"
import style0 from "./perFile1Wx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./perFile1Wx.vue?vue&type=style&index=1&id=6191d447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6191d447",
  null
  
)

export default component.exports